var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Sutl } from '../../../../sutl';
import { forEachConfig } from '../framework/DspConfig';
import { Timeouts } from '../framework/Timeouts';
import { Resource } from '../Radius';
class Controller {
    constructor(socket, properties) {
        this.socket = socket;
        this.canGet = properties.canGet;
        this.isPush = properties.isPush;
        this.number = properties.number;
        if (properties.telephony)
            this.telephony = properties.telephony;
        this.value = properties.value;
    }
    queryGs2() {
        this.socket.send(`${this.number} ${this.value}`);
    }
    queryPush() {
        const cn = this.number.toString().padStart(5, '0');
        const value = this.value.toString().padStart(5, '0');
        this.socket.send(`${cn}=${value}`);
    }
    set(value) {
        this.value = value;
        if (this.isPush) {
            const cnStr = this.number.toString().padStart(5, '0');
            const valueStr = this.value.toString().padStart(5, '0');
            this.socket.send(`#${cnStr}=${valueStr}`);
        }
    }
    toggle() {
        this.set(this.value > 0 ? 0 : 65535);
    }
}
class Controllers {
    constructor(socket, initialControllers) {
        this.socket = socket;
        this.controllers = [];
        if (initialControllers !== undefined) {
            for (const props of initialControllers) {
                if (this.find(props.number))
                    throw new Error(`duplicate controller number`);
                this.controllers.push(new Controller(socket, props));
            }
        }
    }
    add(controllerNumber, isPush = true) {
        if (this.find(controllerNumber))
            throw new Error(`duplicate controller number`);
        const controller = new Controller(this.socket, {
            canGet: true,
            isPush,
            number: controllerNumber,
            value: 0,
        });
        this.controllers.push(controller);
        return controller;
    }
    clear() {
        this.controllers.length = 0;
    }
    find(controllerNumber) {
        return this.controllers.find(c => c.number === controllerNumber);
    }
    findTelephony(unitOrController, cardOrType, line, type) {
        if (typeof unitOrController === 'number' &&
            typeof cardOrType === 'number' &&
            line !== undefined &&
            type !== undefined) {
            const unit = unitOrController;
            const card = cardOrType;
            return this.controllers.find(c => {
                var _a, _b, _c, _d;
                return ((_a = c.telephony) === null || _a === void 0 ? void 0 : _a.unit) === unit &&
                    ((_b = c.telephony) === null || _b === void 0 ? void 0 : _b.card) === card &&
                    ((_c = c.telephony) === null || _c === void 0 ? void 0 : _c.line) === line &&
                    ((_d = c.telephony) === null || _d === void 0 ? void 0 : _d.type) === type;
            });
        }
        else if (typeof unitOrController !== 'number' && typeof cardOrType !== 'number') {
            const controller = unitOrController;
            type = cardOrType;
            const telephony = controller.telephony;
            if (telephony === undefined)
                return undefined;
            return this.findTelephony(telephony.unit, telephony.card, telephony.line, type);
        }
        return undefined;
    }
    forEach(fn) {
        return this.controllers.forEach(fn);
    }
    update(controllerNumber, isPush = true, telProps) {
        var _a;
        const controller = (_a = this.find(controllerNumber)) !== null && _a !== void 0 ? _a : this.add(controllerNumber, false);
        controller.isPush = isPush;
        controller.telephony = telProps;
    }
}
class SystemString {
    constructor(socket, properties, value = '') {
        this.socket = socket;
        this.card = properties.card;
        this.line = properties.line;
        this.num = properties.num;
        this.resource = properties.resource;
        this.unit = properties.unit;
        this.key = `${this.unit}.${this.resource}.${this.num}.${this.card}.${this.line}`;
        this.value = value;
    }
    get props() {
        return {
            card: this.card,
            line: this.line,
            num: this.num,
            resource: this.resource,
            unit: this.unit,
        };
    }
    queryGsyss() {
        this.socket.send(this.value);
    }
    queryPush() {
        this.socket.send(`${this.key}=${this.value}`);
    }
    set(value) {
        this.value = value;
        this.queryPush();
    }
}
class SystemStrings {
    constructor(socket, initialStrings) {
        this.socket = socket;
        this.systemStrings = [];
        for (const props of initialStrings !== null && initialStrings !== void 0 ? initialStrings : []) {
            if (this.find(props)) {
                throw new Error(`duplicate system string`);
            }
            this.add(props);
        }
    }
    add(unitOrProps, resourceOrValue, num, card, line, value) {
        if (typeof unitOrProps === 'number' && typeof resourceOrValue === 'number') {
            const unit = unitOrProps;
            const resource = resourceOrValue;
            return this.add({
                unit,
                resource: resource !== null && resource !== void 0 ? resource : 0,
                num: num !== null && num !== void 0 ? num : 0,
                card: card !== null && card !== void 0 ? card : 0,
                line: line !== null && line !== void 0 ? line : 0,
            }, value !== null && value !== void 0 ? value : '');
        }
        else if (typeof unitOrProps !== 'number' &&
            (resourceOrValue === undefined || typeof resourceOrValue === 'string')) {
            const props = unitOrProps;
            value = resourceOrValue;
            if (this.find(props))
                throw new Error(`duplicate system string`);
            const ss = new SystemString(this.socket, props, value);
            this.systemStrings.push(ss);
            return ss;
        }
        else {
            throw new Error('invalid arguments');
        }
    }
    clear() {
        this.systemStrings.length = 0;
    }
    find(unitOrProps, resource, num, card, line) {
        if (typeof unitOrProps !== 'number') {
            const props = unitOrProps;
            return this.find(props.unit, props.resource, props.num, props.card, props.line);
        }
        return this.systemStrings.find(ss => ss.unit === unitOrProps &&
            ss.resource === resource &&
            ss.num === num &&
            ss.card === card &&
            ss.line === line);
    }
    update(props, value = '') {
        Sutl.filterInPlace(this.systemStrings, ss => ss.card !== props.card ||
            ss.line !== props.line ||
            ss.num !== props.num ||
            ss.resource !== props.resource ||
            ss.unit !== props.unit);
        this.add(props, value);
    }
}
export class Radius {
    constructor(socket, log) {
        this.socket = socket;
        this.timeouts = new Timeouts();
        this.asyncHandlers = [
            {
                regExp: /^CS(Q*)\s+(\d+)\s+(\d+)$/,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c, _d;
                    const isQuick = match[1] === 'Q';
                    const cn = parseInt(match[2], 10);
                    const controller = this.controllers.find(cn);
                    if (controller || isQuick)
                        this.socket.send(`ACK`);
                    if (controller) {
                        controller.set(parseInt(match[3], 10));
                        if (((_a = controller.telephony) === null || _a === void 0 ? void 0 : _a.type) === 'callEnd') {
                            // Only for VoIP.
                            const telProps = Object.assign(Object.assign({}, controller.telephony), { num: 0 });
                            const callStatus = this.systemStrings.find(Object.assign(Object.assign({}, telProps), { resource: Resource.CallStatus }));
                            const numberToDial = this.systemStrings.find(Object.assign(Object.assign({}, telProps), { resource: Resource.NumberToDial }));
                            const numberDialed = this.systemStrings.find(Object.assign(Object.assign({}, telProps), { resource: Resource.NumberDialed }));
                            if (callStatus === undefined)
                                return;
                            if (callStatus.value === 'Idle' &&
                                numberToDial &&
                                numberToDial.value.length > 0) {
                                numberDialed === null || numberDialed === void 0 ? void 0 : numberDialed.set(numberToDial.value);
                                callStatus.set(`Dialing: ${numberToDial.value}`);
                                numberDialed === null || numberDialed === void 0 ? void 0 : numberDialed.set('');
                                callStatus.set(`In Call: ${numberToDial.value}`);
                            }
                            else {
                                callStatus.set(callStatus.value === 'Idle' ? 'Ready' : 'Idle');
                            }
                        }
                        else if (((_b = controller.telephony) === null || _b === void 0 ? void 0 : _b.type) === 'connectDisconnect') {
                            // Only for PSTN.
                            const connectedLed = this.controllers.findTelephony(controller, 'connectedLed');
                            if (connectedLed === undefined)
                                return;
                            connectedLed.set(connectedLed.value === 0 ? 65535 : 0);
                            if (connectedLed.value === 0 && connectedLed.telephony) {
                                (_c = this.systemStrings
                                    .find(Object.assign(Object.assign({}, connectedLed.telephony), { num: 0, resource: Resource.NumberDialed }))) === null || _c === void 0 ? void 0 : _c.set('');
                            }
                        }
                        else if (((_d = controller.telephony) === null || _d === void 0 ? void 0 : _d.type) === 'speedDial') {
                            // Only for PSTN.
                            //
                            // Assume that the speed dial controller refers to the correct speed dial
                            // system string.
                            const speedDial = this.systemStrings.find(Object.assign(Object.assign({}, controller.telephony), { num: 19, resource: Resource.SpeedDial }));
                            if (speedDial === undefined || speedDial.value === '')
                                return;
                            const telProps = Object.assign(Object.assign({}, controller.telephony), { num: 0 });
                            const speedDialStr = this.systemStrings.find(Object.assign(Object.assign({}, telProps), { resource: Resource.SpeedDial }));
                            const numberDialed = this.systemStrings.find(Object.assign(Object.assign({}, telProps), { resource: Resource.NumberDialed }));
                            const connectedLed = this.controllers.findTelephony(controller, 'connectedLed');
                            if (speedDialStr && numberDialed) {
                                numberDialed.set(numberDialed.value + speedDialStr.value);
                            }
                            if ((connectedLed === null || connectedLed === void 0 ? void 0 : connectedLed.value) === 0) {
                                yield this.timeouts.delay(100);
                                connectedLed.set(65535);
                            }
                        }
                    }
                    else {
                        this.socket.send(`NAK`);
                    }
                }),
            },
            {
                regExp: /^FU\s+(\d+)$/,
                callback: (match) => {
                    this.socket.send(`ACK`);
                },
            },
            {
                regExp: /^GPU$/,
                callback: (match) => {
                    this.controllers.forEach(controller => {
                        if (controller.isPush) {
                            this.socket.send(controller.number.toString().padStart(5, '0'));
                        }
                    });
                },
            },
            {
                regExp: /^GS2\s+(\d+)$/,
                callback: (match) => {
                    const cn = parseInt(match[1], 10);
                    const controller = this.controllers.find(cn);
                    if (controller) {
                        controller.queryGs2();
                    }
                    else {
                        this.socket.send(`NAK`);
                    }
                },
            },
            {
                regExp: /^GSYSS\s+(\d+)\.(\d+)\.(\d+)\.(\d+)\.(\d+)$/,
                callback: (match) => {
                    const unit = parseInt(match[1], 10);
                    const resource = parseInt(match[2], 10);
                    const num = parseInt(match[3], 10);
                    const card = parseInt(match[4], 10);
                    const line = parseInt(match[5], 10);
                    const ss = this.systemStrings.find(unit, resource, num, card, line);
                    if (ss === undefined) {
                        this.socket.send(`NAK`);
                    }
                    else {
                        ss.queryGsyss();
                    }
                },
            },
            {
                regExp: /^LP\s+(\d+)$/,
                callback: (match) => {
                    this.socket.send(`ACK`);
                },
            },
            {
                regExp: /^NOP$/,
                callback: (match) => {
                    this.socket.send(`ACK`);
                },
            },
            {
                regExp: /^PUR$/,
                callback: (match) => {
                    this.socket.send(`ACK`);
                    this.controllers.forEach(controller => {
                        if (controller.isPush)
                            controller.queryPush();
                    });
                },
            },
            {
                regExp: /^RI$/,
                callback: (match) => {
                    this.socket.send(`192.168.1.100`);
                },
            },
            {
                regExp: /^SSYSS\s+(\d+)\.(\d+)\.(\d+)\.(\d+)\.(\d+)=(.+)$/,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    const unit = parseInt(match[1], 10);
                    const resource = parseInt(match[2], 10);
                    const num = parseInt(match[3], 10);
                    const card = parseInt(match[4], 10);
                    const line = parseInt(match[5], 10);
                    const value = match[6];
                    const ss = this.systemStrings.find(unit, resource, num, card, line);
                    if (ss === undefined) {
                        this.socket.send(`NAK`);
                    }
                    else {
                        this.socket.send(`ACK`);
                        yield this.timeouts.delay(100);
                        ss.set(value);
                        if (ss.resource === Resource.NumberToDial) {
                            const callStatusStr = this.systemStrings.find(ss.unit, Resource.CallStatus, 0, ss.card, ss.line);
                            // Inara always sends the full string in one SSYSS command, so we don't have
                            // to worry about the dialing plan and when to place the call. This behavior
                            // doesn't match the real device, but it is fine for the emulator.
                            if ((callStatusStr === null || callStatusStr === void 0 ? void 0 : callStatusStr.value) === 'Ready') {
                                const dialStr = ss.value;
                                yield this.timeouts.delay(100);
                                callStatusStr.set(`Dialing: ${dialStr}`);
                                yield this.timeouts.delay(100);
                                ss.set('');
                                callStatusStr.set(`In Call: ${dialStr}`);
                            }
                        }
                    }
                }),
            },
            {
                regExp: /^\$v V$/,
                callback: (match) => {
                    this.socket.send(``);
                    this.socket.send(`Firmware Version:     V8.1.0.26`);
                    this.socket.send(`Build Date:           Tue Sep 14 14:24:02 PDT 2021`);
                    this.socket.send(`Internal Build:       V20.26`);
                    this.socket.send(`Linux Version:        V3.2.0.3332`);
                    this.socket.send(`Dante firmware:       Kernel V4.0.7, User V7.05`);
                    this.socket.send(`Main firmware:        V8.1.0.26  (Tue Sep 14 21:24:02 2021)`);
                    this.socket.send(`Startup firmware:     V2.77  (Mon May 24 19:13:19 2021)`);
                    this.socket.send(`Front panel firmware: V2.71  (Wed Jan  8 23:31:12 2020)`);
                    this.socket.send(`RS-485 firmware:      V1.56  (Sat Nov 23 00:44:44 2019)`);
                    this.socket.send(`RS-232 firmware:      V2.13  (Mon Sep 28 18:57:10 2020)`);
                    this.socket.send(`ARC-Web executable:   V1.23  (Sat Nov 23 00:28:27 2019)`);
                    this.socket.send(`ARC-Web CGI firmware: V1.23  (Sat Nov 23 00:36:56 2019)`);
                    this.socket.send(`ARC-Mix CGI firmware: V1.26  (Sat Oct 17 00:15:33 2020)`);
                    this.socket.send(`Dialer CGI firmware:  V1.79  (Sat Nov 23 00:21:57 2019)`);
                    this.socket.send(`Shure firmware:       V1.21  (Thu Feb 20 19:07:53 2020)`);
                    this.socket.send(`VSI firmware:         V1.08  (Thu Feb 20 19:09:45 2020)`);
                    this.socket.send(`Powersoft firmware:   V1.32  (Thu Feb 20 19:01:40 2020)`);
                    this.socket.send(`Scripting firmware:   V2.30  (Thu Jun 17 21:46:22 2021)`);
                    this.socket.send(`HTTP firmware:        V1.02  (Tue Nov 26 01:25:53 2019)`);
                    this.socket.send(`Additional Info:`);
                    this.socket.send(`Linux version 3.2.0-ADI-2012R1-pre-9-pae+ (uclinux-devel@linux-tclw)`);
                    this.socket.send(`(gcc version 4.3.5 (ADI-2010R1-RC4) ) #3332 Wed Sep 20 16:34:06 PDT 2017`);
                    this.socket.send(`TCP/IP instance #1 of 6`);
                    this.socket.sendRaw(`>`);
                },
            },
            {
                regExp: /^V$/,
                callback: (match) => {
                    this.socket.send(`V8.1.0.26`);
                    this.socket.send(`Tue Sep 14 14:24:02 PDT 2021`);
                    this.socket.send(`V20.26`);
                    this.socket.send(`3.2.0.3332`);
                    this.socket.send(`K:4.0.7 U:7.05`);
                    this.socket.send(`V8.1.0.26  (Tue Sep 14 21:24:02 2021)`);
                    this.socket.send(`V2.77  (Mon May 24 19:13:19 2021)`);
                    this.socket.send(`V2.71  (Wed Jan  8 23:31:12 2020)`);
                    this.socket.send(`V1.56  (Sat Nov 23 00:44:44 2019)`);
                    this.socket.send(`V2.13  (Mon Sep 28 18:57:10 2020)`);
                    this.socket.send(`N/A`);
                    this.socket.send(`V1.23  (Sat Nov 23 00:28:27 2019)`);
                    this.socket.send(`V1.23  (Sat Nov 23 00:36:56 2019)`);
                    this.socket.send(`V1.26  (Sat Oct 17 00:15:33 2020)`);
                    this.socket.send(`V1.79  (Sat Nov 23 00:21:57 2019)`);
                    this.socket.send(`V1.21  (Thu Feb 20 19:07:53 2020)`);
                    this.socket.send(`V1.08  (Thu Feb 20 19:09:45 2020)`);
                    this.socket.send(`N/A`);
                    this.socket.send(`V1.32  (Thu Feb 20 19:01:40 2020)`);
                    this.socket.send(`V2.30  (Thu Jun 17 21:46:22 2021)`);
                    this.socket.send(`N/A`);
                    this.socket.send(`V1.02  (Tue Nov 26 01:25:53 2019)`);
                    this.socket.send(`N/A`);
                },
            },
            {
                regExp: /.+/,
                callback: (match) => {
                    this.socket.send(`NAK`);
                },
            },
        ];
        this.controllers = new Controllers(socket);
        this.systemStrings = new SystemStrings(this.socket);
    }
    onConfigure(config) {
        this.timeouts.clearAll();
        this.controllers.clear();
        this.systemStrings.clear();
        // Add default control points.
        this.controllers.add(101, false);
        this.controllers.add(102, false);
        this.controllers.add(103, false);
        this.controllers.add(104, false);
        this.controllers.add(105, false);
        this.controllers.add(106, false);
        this.controllers.add(107, false);
        this.controllers.add(108, false);
        this.controllers.add(109, false);
        this.controllers.add(110, false);
        this.controllers.add(111, false);
        this.controllers.add(112, false);
        this.controllers.add(113, false);
        this.controllers.add(117, false);
        this.controllers.add(118, true);
        this.controllers.add(121, true);
        this.controllers.add(145, false);
        this.controllers.add(250, true);
        this.controllers.add(251, true);
        this.controllers.add(260, true);
        this.controllers.add(262, true);
        this.controllers.add(263, true);
        this.controllers.add(301, true);
        this.controllers.add(312, true);
        this.controllers.add(422, true);
        const telProps = { unit: 1, num: 0, card: 3 };
        this.systemStrings.add(Object.assign(Object.assign({}, telProps), { resource: Resource.SpeedDial, num: 19, line: 0 }));
        this.systemStrings.add(Object.assign(Object.assign({}, telProps), { resource: Resource.SpeedDial, num: 19, line: 1 }));
        this.systemStrings.add(Object.assign(Object.assign({}, telProps), { resource: Resource.NumberDialed, line: 0 }));
        this.systemStrings.add(Object.assign(Object.assign({}, telProps), { resource: Resource.NumberDialed, line: 1 }));
        this.systemStrings.add(Object.assign(Object.assign({}, telProps), { resource: Resource.CallerId, line: 0 }));
        this.systemStrings.add(Object.assign(Object.assign({}, telProps), { resource: Resource.CallerId, line: 1 }));
        this.systemStrings.add(Object.assign(Object.assign({}, telProps), { resource: Resource.NumberToDial, line: 0 }));
        this.systemStrings.add(Object.assign(Object.assign({}, telProps), { resource: Resource.NumberToDial, line: 1 }));
        this.systemStrings.add(Object.assign(Object.assign({}, telProps), { resource: Resource.CallStatus, line: 0 }), 'Idle');
        this.systemStrings.add(Object.assign(Object.assign({}, telProps), { resource: Resource.CallStatus, line: 1 }), 'Idle');
        // Add control points defined in the config.
        forEachConfig(config, (path, type, config) => {
            if (type === 'mute' || type === 'volume') {
                if (typeof config === 'number') {
                    this.controllers.update(config);
                }
                else if (typeof config === 'object' &&
                    'muteStatus' in config &&
                    typeof config.muteStatus === 'number') {
                    this.controllers.update(config.muteStatus);
                }
            }
            else if (type === 'telephony') {
                if (typeof config === 'object' && 'callType' in config) {
                    this.controllers.update(config.keypad0, false);
                    this.controllers.update(config.keypad1, false);
                    this.controllers.update(config.keypad2, false);
                    this.controllers.update(config.keypad3, false);
                    this.controllers.update(config.keypad4, false);
                    this.controllers.update(config.keypad5, false);
                    this.controllers.update(config.keypad6, false);
                    this.controllers.update(config.keypad7, false);
                    this.controllers.update(config.keypad8, false);
                    this.controllers.update(config.keypad9, false);
                    this.controllers.update(config.keypadPound, false);
                    this.controllers.update(config.keypadStar, false);
                    if (config.receiveGain)
                        this.controllers.update(config.receiveGain);
                    if (config.callType === 'pstn') {
                        this.controllers.update(config.connectDisconnect, false, Object.assign(Object.assign({}, config), { type: 'connectDisconnect' }));
                        this.controllers.update(config.connectedLed, true, Object.assign(Object.assign({}, config), { type: 'connectedLed' }));
                        this.controllers.update(config.ringingLed, true, Object.assign(Object.assign({}, config), { type: 'ringingLed' }));
                        this.controllers.update(config.speedDial, false, Object.assign(Object.assign({}, config), { type: 'speedDial' }));
                    }
                    else if (config.callType === 'voip') {
                        this.controllers.update(config.callEnd, false, Object.assign(Object.assign({}, config), { type: 'callEnd' }));
                        this.controllers.update(config.reject, false, Object.assign(Object.assign({}, config), { type: 'reject' }));
                    }
                    const telProps = {
                        unit: config.unit,
                        num: 0,
                        card: config.card,
                        line: config.line,
                    };
                    this.systemStrings.update(Object.assign(Object.assign({}, telProps), { resource: Resource.CallerId }));
                    this.systemStrings.update(Object.assign(Object.assign({}, telProps), { resource: Resource.CallStatus }), 'Idle');
                    this.systemStrings.update(Object.assign(Object.assign({}, telProps), { resource: Resource.NumberDialed }));
                    this.systemStrings.update(Object.assign(Object.assign({}, telProps), { resource: Resource.NumberToDial }));
                    this.systemStrings.update(Object.assign(Object.assign({}, telProps), { resource: Resource.SpeedDial, num: 19 }));
                }
            }
        });
    }
    onDisconnect() {
        this.timeouts.clearAll();
    }
}
Radius.emulatorType = 'socketEmulator';
Radius.key = '-L-7rxdze1CkSjtklwbg';
